import React, { useEffect, useRef, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion, useScroll, useTransform, AnimatePresence, useMotionValueEvent, useInView, useMotionValue, useSpring, animate } from "framer-motion";
import { FaPlay, FaArrowRight, FaGlobeAsia, FaCertificate, FaUsers,  FaMobileAlt, FaUserFriends, FaAward, FaUserCheck, FaLeaf, FaBrain, FaHeartbeat, FaChild, FaChalkboardTeacher, FaSpa, FaSun, FaWeight, FaStar, FaQuoteRight, FaPlayCircle, FaBookOpen, FaHeart, FaPause, FaGoogle, FaVideo, FaLock } from "react-icons/fa";
import { MdAccessTimeFilled, MdSelfImprovement } from "react-icons/md";
import { toast } from "react-toastify";
import HeroSection from "../components/HeroSection";
import { liveSessionAPI, userAPI } from "../services/api";

const getTierRank = (tierName) => {
  if (!tierName) return 0;
  const t = String(tierName).toLowerCase().trim();
  if (t.includes("pro") || t.includes("ytt") || t.includes("vip") || t.includes("diamond") || t.includes("master")) return 4;
  if (t.includes("premium") || t.includes("gold")) return 3;
  if (t.includes("standard") || t.includes("silver")) return 2;
  if (t.includes("basic") || t.includes("bronze")) return 1;
  return 0; // Free / Trial
};


const benefitsData = [
  { id:1, number:"01", icon:<FaAward/>,            title:"Expert Led Yoga Classes",       highlight:"International Gold Medalist", subtitle:"Learn directly from Mrs. Divya Nithin Bhojwani, an internationally recognized Gold Medalist in Yoga, guiding students through authentic wellness and transformational practices.", image:"/assets/image 44.png" },
  { id:2, number:"02", icon:<FaGlobeAsia/>,         title:"Global Wellness Access",        highlight:"Join From Anywhere",          subtitle:"Access immersive live and on demand yoga sessions from anywhere in the world through a seamless premium digital wellness experience.", image:"/assets/image 45.png" },
  { id:3, number:"03", icon:<FaMobileAlt/>,         title:"Multi Device Experience",       highlight:"Web • Android • iOS",         subtitle:"Continue your wellness journey effortlessly across web, Android, and iOS platforms with smooth synchronized learning experiences.", image:"/assets/image 46.png" },
  { id:4, number:"04", icon:<MdAccessTimeFilled/>,  title:"Flexible Batch Scheduling",     highlight:"Morning • Evening • Weekend", subtitle:"Choose personalized learning schedules that fit your lifestyle with flexible yoga batches designed for working professionals and students.", image:"/assets/image 47.png" },
  { id:5, number:"05", icon:<FaUserFriends/>,       title:"Interactive Community Support", highlight:"Real Time Guidance",          subtitle:"Engage with instructors and fellow learners through a connected wellness community focused on growth, support, and mindfulness.", image:"/assets/image 48.png" },
  { id:6, number:"06", icon:<FaCertificate/>,       title:"Certified Learning Programs",   highlight:"Digital Certification",       subtitle:"Receive professional digital certificates upon successful course completion to validate your yoga learning and wellness journey.", image:"/assets/image 49.png" },
  { id:7, number:"07", icon:<MdSelfImprovement/>,   title:"Programs For Every Level",      highlight:"Beginner To Advanced",        subtitle:"Structured yoga programs designed for beginners, intermediate practitioners, and advanced learners with progressive guidance.", image:"/assets/image 50.png" },
  { id:8, number:"08", icon:<FaUserCheck/>,         title:"Personalized Wellness Guidance",highlight:"One On One Support",          subtitle:"Receive customized wellness recommendations, one on one consultations, and guided yoga plans tailored to your goals.", image:"/assets/image 51.png" },
]

const programsData = [
  { id:1,  icon:<FaLeaf/>,             title:"Beginner Yoga",     duration:"4 Weeks",  level:"Beginner",    image:"/assets/image 32.png",  link:"/courses/beginner-yoga" },
  { id:2,  icon:<FaSpa/>,              title:"Intermediate Yoga", duration:"6 Weeks",  level:"Intermediate", image:"/assets/image 33.png",  link:"/courses/intermediate-yoga" },
  { id:3,  icon:<FaBrain/>,            title:"Advanced Yoga",     duration:"8 Weeks",  level:"Advanced",    image:"/assets/image 34.jpeg", link:"/courses/advanced-yoga" },
  { id:4,  icon:<FaSun/>,              title:"Morning Wellness",  duration:"Daily",    level:"All Levels",  image:"/assets/image 35.jpeg", link:"/courses/morning-wellness" },
  { id:5,  icon:<FaWeight/>,           title:"Weight Management", duration:"6 Weeks",  level:"Beginner",    image:"/assets/image 36.jpeg", link:"/courses/weight-management" },
  { id:6,  icon:<FaHeartbeat/>,        title:"Stress Relief",     duration:"4 Weeks",  level:"All Levels",  image:"/assets/image 37.jpeg", link:"/courses/stress-relief" },
  { id:7,  icon:<FaSpa/>,              title:"Pre & Post Natal",  duration:"6 Weeks",  level:"Specialized", image:"/assets/image 38.jpeg", link:"/courses/pre-post-natal" },
  { id:8,  icon:<FaChild/>,            title:"Kids Yoga",         duration:"4 Weeks",  level:"Children",    image:"/assets/image 39.jpeg", link:"/courses/kids-yoga" },
  { id:9,  icon:<FaUsers/>,            title:"Senior Wellness",   duration:"Ongoing",  level:"Gentle",      image:"/assets/image 40.jpeg", link:"/courses/senior-wellness" },
  { id:10, icon:<FaChalkboardTeacher/>,title:"Teacher Training",  duration:"30 Days",  level:"Advanced",    image:"/assets/image 41.jpeg", link:"/courses/teacher-training" },
];

const liveSteps = [
  { id:"01", title:"Register",         description:"Choose your preferred yoga batch or live wellness experience.",            small:"Simple onboarding with personalized scheduling." },
  { id:"02", title:"Get Access",       description:"Receive secure live classroom access through email and mobile app.",       small:"Seamless cross-device experience with instant access." },
  { id:"03", title:"Join Live",        description:"Enter immersive virtual yoga sessions from anywhere in the world.",        small:"High quality real time wellness interaction." },
  { id:"04", title:"Practice Together",description:"Follow synchronized yoga guidance and mindfulness practices live.",        small:"Feel connected through shared wellness experiences." },
  { id:"05", title:"Ask & Interact",   description:"Get real time corrections and guidance from expert instructors.",          small:"Interactive voice and live chat support." },
  { id:"06", title:"Replay Anytime",   description:"Access recorded replays anytime directly from your dashboard.",            small:"Never miss your wellness journey again." },
];

const testimonials = [
  { id:1, name:"Priya Sharma",   location:"Mumbai, India",    image:"https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=1200&auto=format&fit=crop", review:"Divyyog Foundation completely transformed my relationship with my body and mind. Mrs. Divya Nithin Bhojwani's teaching feels deeply personal, calming, and spiritually enriching." },
  { id:2, name:"Ravi Kumar",     location:"United States",    image:"https://images.unsplash.com/photo-1500648767791-00dcc994a43e?q=80&w=1200&auto=format&fit=crop", review:"The online classes are beautifully structured. Even from thousands of miles away, every session feels immersive, interactive, and deeply connected." },
  { id:3, name:"Ananya Rao",     location:"Pune, India",      image:"https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=1200&auto=format&fit=crop", review:"From stress relief to weight management, my transformation truly began the day I joined Divyyog Foundation." },
  { id:4, name:"Mohammed Ali",   location:"Dubai, UAE",       image:"https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=1200&auto=format&fit=crop", review:"The flexibility of scheduling and quality of instruction is unmatched. I attend classes regularly from Dubai and never miss a session." },
];

const statsData = [
  { id:1, number:1000, suffix:"+", title:"Students Enrolled",        icon:<FaUsers/> },
  { id:2, number:15,   suffix:"+", title:"Countries Reached",        icon:<FaGlobeAsia/> },
  { id:3, number:50,   suffix:"+", title:"Live Sessions Monthly",    icon:<FaPlayCircle/> },
  { id:4, number:20,   suffix:"+", title:"Courses Available",        icon:<FaBookOpen/> },
  { id:5, number:5,    suffix:"+", title:"Years of Teaching Excellence", icon:<FaAward/> },
  { id:6, number:98,   suffix:"%", title:"Satisfaction Rate",        icon:<FaHeart/> },
];

const pricingPlans = [
  { title:"Free Trial",         price:"₹0",     badge:"Starter Access",      description:"Begin your wellness journey with guided beginner experiences, live yoga introductions, and mindful healing sessions designed for first time practitioners.", features:["7-Day Premium Trial Access","1 Beginner Yoga Course","2 Live Interactive Classes","Guided Meditation Sessions","Mobile & Tablet Access"] },
  { title:"Basic Membership",   price:"₹999",   badge:"Casual Wellness",      description:"Perfect for occasional practitioners seeking flexible wellness routines, curated yoga experiences, and weekly live learning from expert instructors.", features:["2 Courses Per Month","3 Live Classes Weekly","Session Recordings Access","Breathing & Meditation Modules","Beginner Friendly Programs"] },
  { title:"Standard",           price:"₹1,999", badge:"Most Popular", featured:true, features:["Unlimited Courses","Daily Live Classes","All Recordings Access","Community Access","Progress Tracking"] },
  { title:"Premium Membership", price:"₹3,999", badge:"Elite Transformation", description:"Designed for serious practitioners seeking deep transformation through private mentorship, advanced healing programs, and certification-focused guidance.", features:["Everything in Standard Plan","1 Monthly one on one Session","Priority Wellness Support","Advanced Healing Programs","Certificate Eligibility Access"] },
  { title:"YTT / Pro",          price:"₹7,999", badge:"Instructor Pathway",   description:"Professional teacher training experience for aspiring instructors with immersive mentorship, advanced learning frameworks, and global certification preparation.", features:["Full Yoga Teacher Training","Unlimited Premium Courses","Weekly Expert Mentorship","Certification Preparation","Professional Instructor Community"] },
];

// ─── REUSABLE COMPONENTS ─────────────────────────────────────────────────────

// Smooth scroll reveal   wraps any section content
const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y, filter: "blur(8px)" }}
    whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.85, ease: [0.16, 1, 0.3, 1], delay }}
    style={{ willChange: "transform, opacity, filter" }}
    className={className}>
    {children}
  </motion.div>
);

// Shared section badge
const Badge = ({ label, dark = false }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2, duration: 0.8 }}
    className={`inline-flex items-center gap-3 px-5 py-3 rounded-full border mt-8 ${dark ? "bg-white/10 border-white/20" : "bg-[#F29A0C]/10 border-[#F29A0C]/20"}`}>
    <div className={`w-2 h-2 rounded-full ${dark ? "bg-white" : "bg-[#F29A0C]"}`} />
    <span className={`tracking-[3px] uppercase text-xs font-semibold ${dark ? "text-white" : "text-[#F29A0C]"}`}>{label}</span>
  </motion.div>
);

// Pricing side card (shared between left/right columns)
const PricingSideCard = ({ plan }) => (
  <motion.div whileHover={{ y: -10 }}
    className="group relative overflow-hidden rounded-[38px] border border-[#F4D9B5] bg-white/60 backdrop-blur-2xl p-8 shadow-[0_30px_100px_rgba(0,0,0,0.04)] hover:border-[#F29A0C]/40 transition-all duration-700">
    <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-all duration-700 bg-[radial-gradient(circle_at_center,rgba(242,154,12,0.14),transparent_70%)]" />
    <div className="relative z-20">
      <span className="text-[#F29A0C] text-xs tracking-[3px] uppercase font-semibold">{plan.badge}</span>
      <h3 className="text-[48px] leading-none tracking-[-3px] font-semibold text-[#111111] mt-7">{plan.price}</h3>
      <p className="text-[#111111] text-[24px] font-semibold mt-4">{plan.title}</p>
      <div className="max-h-0 overflow-hidden opacity-0 group-hover:max-h-[500px] group-hover:opacity-100 transition-all duration-700">
        <p className="text-[#666666] text-[16px] leading-[30px] mt-6">{plan.description}</p>
        <div className="space-y-4 mt-8">
          {plan.features?.map((f, i) => (
            <div key={i} className="flex items-center gap-4">
              <div className="w-2 h-2 rounded-full bg-[#F29A0C]" />
              <span className="text-[#444444] text-[15px]">{f}</span>
            </div>
          ))}
        </div>
        <motion.button whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.97 }}
          className="mt-8 w-full rounded-full bg-[#F29A0C] text-white py-4 text-[15px] font-semibold shadow-[0_20px_60px_rgba(242,154,12,0.18)]">
          Choose Plan
        </motion.button>
      </div>
    </div>
  </motion.div>
);

// ─── MAIN COMPONENT ───────────────────────────────────────────────────────────
const Home = () => {
  const [activeBenefit, setActiveBenefit] = useState(0);
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [isPaused, setIsPaused]         = useState(false);
  const [activeIndex, setActiveIndex]   = useState(0);
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);
  const [isMobile, setIsMobile]         = useState(false);
  const scrollRef  = useRef(null);
  const sectionRef = useRef(null);
  const liveClassesRef = useRef(null);
  const isInView   = useInView(sectionRef, { amount: 0.4 });
  const marqueeRef = useRef(null);
  const playback   = useRef(null);
  const navigate = useNavigate();
  const [authState, setAuthState] = useState({ loggedIn: false, role: "user", user: null });
  const [userProfile, setUserProfile] = useState(null);
  const [, setLiveSessions] = useState([]);
  const [activeLiveSession, setActiveLiveSession] = useState(null);
  const [isLiveNow, setIsLiveNow] = useState(false);

  // Helper to determine if a session is currently actively streaming
  const checkIsSessionLive = (s) => {
    if (!s) return false;
    const status = (s.status || s.Status || "").toLowerCase();
    if (status === "live") return true;
    if (s.isLive || s.IsLive) return true;
    const now = Date.now();
    let dateStr = String(s.scheduledAt || s.ScheduledAt || "");
    if (!dateStr) return false;
    if (!dateStr.endsWith("Z") && !dateStr.includes("+") && !dateStr.includes("-")) {
      dateStr += "Z";
    }
    const start = new Date(dateStr).getTime();
    const duration = Number(s.durationInMinutes || s.DurationInMinutes) || 60;
    const end = start + duration * 60000;
    return now >= start && now <= end;
  };

  useEffect(() => {
    const token = localStorage.getItem("divyayoga_token");
    const role = (localStorage.getItem("divyayoga_role") || "").toLowerCase();
    const user = JSON.parse(localStorage.getItem("divyayoga_user") || "null");
    setAuthState({
      loggedIn: !!token,
      role: role || "user",
      user,
    });

    if (token) {
      userAPI.getProfile()
        .then((res) => {
          if (res?.data?.success && res.data.data) {
            setUserProfile(res.data.data);
          }
        })
        .catch(() => {});
    }

    liveSessionAPI.getSessions()
      .then((res) => {
        const list = Array.isArray(res?.data?.data) ? res.data.data : (Array.isArray(res?.data) ? res.data : []);
        setLiveSessions(list);
        if (list.length > 0) {
          const liveNow = list.find((s) => checkIsSessionLive(s));
          if (liveNow) {
            setActiveLiveSession(liveNow);
            setIsLiveNow(true);
          } else {
            setActiveLiveSession(list[0]);
            setIsLiveNow(false);
          }
        } else {
          setActiveLiveSession(null);
          setIsLiveNow(false);
        }
      })
      .catch((err) => {
        console.warn("Failed to fetch live sessions for home page:", err);
      });
  }, []);

  const userRank = useMemo(() => {
    if (!authState.loggedIn) return 0;
    if (authState.role.includes("admin")) return 4;
    const tierName =
      userProfile?.activeSubscription?.packageName ||
      userProfile?.tier ||
      authState.user?.subscriptionTier ||
      authState.user?.tier ||
      "Basic";
    return getTierRank(tierName);
  }, [authState, userProfile]);

  const requiredRank = useMemo(() => {
    if (!activeLiveSession) return 1;
    const tierName = activeLiveSession.tier || activeLiveSession.Tier || "Basic";
    return getTierRank(tierName);
  }, [activeLiveSession]);

  const isEligible = useMemo(() => {
    if (!authState.loggedIn || !isLiveNow) return false;
    if (authState.role.includes("admin")) return true;
    return userRank >= requiredRank;
  }, [authState, isLiveNow, userRank, requiredRank]);

  const handleLiveSessionJoin = () => {
    if (!authState.loggedIn) {
      toast.info("Please register or log in to join live sessions!");
      navigate("/register");
      return;
    }

    if (!isEligible) {
      toast.warn("This live session requires a higher membership tier. Please upgrade your plan to join!");
      navigate("/pricing");
      return;
    }

    // Eligible user joins directly into the live studio room
    if (activeLiveSession?.id) {
      toast.success("Connecting to Live Session Studio...");
      navigate(`/live-room/${activeLiveSession.id}`);
    } else {
      navigate("/live-classes");
    }
  };

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const handleMouseDown = (e) => {
    const container = scrollRef.current;
    if (!container) return;
    container.classList.add("cursor-grabbing");
    container.classList.remove("scroll-smooth");
    const startX = e.pageX - container.offsetLeft;
    const scrollLeft = container.scrollLeft;

    const handleMouseMove = (moveEvent) => {
      const x = moveEvent.pageX - container.offsetLeft;
      const walk = (x - startX) * 1.5; // Drag speed multiplier
      container.scrollLeft = scrollLeft - walk;
    };

    const handleMouseUpOrLeave = () => {
      container.classList.remove("cursor-grabbing");
      container.classList.add("scroll-smooth");
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUpOrLeave);
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUpOrLeave);
  };

  useEffect(() => {
    if (!marqueeRef.current) return;
    playback.current = animate(
      marqueeRef.current,
      { x: ["0%", "-50%"] },
      { repeat: Infinity, duration: 26, ease: "linear" }
    );
    return () => playback.current?.cancel();
  }, []);

  const { scrollYProgress } = useScroll({ target: liveClassesRef, offset: ["start start", "end end"] });
  const smoothScrollY = useSpring(scrollYProgress, { stiffness: 100, damping: 30, restDelta: 0.001 });
  const activeStep = useTransform(smoothScrollY, [0, 1], [0, liveSteps.length - 1]);

  const rotateX = useMotionValue(0);
  const rotateY = useMotionValue(0);
  const smoothRotateX = useSpring(rotateX, { stiffness: 400, damping: 30, mass: 0.5 });
  const smoothRotateY = useSpring(rotateY, { stiffness: 400, damping: 30, mass: 0.5 });
  const resetTilt = () => { rotateX.set(0); rotateY.set(0); };

  useMotionValueEvent(activeStep, "change", (latest) => {
    setActiveIndex(Math.min(liveSteps.length - 1, Math.max(0, Math.round(latest))));
  });

  useEffect(() => {
    if (!isInView) return;
    const interval = setInterval(() => setActiveBenefit(p => p === benefitsData.length - 1 ? 0 : p + 1), 10000);
    return () => clearInterval(interval);
  }, [isInView]);

  // Infinite auto-scroll for desktop marquee, disabled on mobile
  useEffect(() => {
    const container = scrollRef.current;
    if (!container || isMobile) {
      if (container) container.scrollLeft = 0; // ensure mobile starts at 0
      return;
    }
    let animationFrame;
    const scroll = () => {
      if (!isPaused) {
        container.scrollLeft += 1.8;
        if (container.scrollLeft >= container.scrollWidth / 2) {
          container.scrollLeft = 0;
        }
      }
      animationFrame = requestAnimationFrame(scroll);
    };
    scroll();
    return () => cancelAnimationFrame(animationFrame);
  }, [isPaused, isMobile]);

  // Seed particles once to prevent glitching on re-render
  const particles = useMemo(() => {
    return Array.from({ length: 20 }).map((_, i) => ({
      id: i,
      width: `${(i % 3) + 2}px`,
      height: `${(i % 3) + 2}px`,
      top: `${((i * 17) % 80) + 10}%`,
      left: `${((i * 23) % 80) + 10}%`,
      duration: `${8 + (i % 6)}s`,
      delay: `${i * 0.4}s`,
    }));
  }, []);

  return (
    <>
      {/* Dynamic Keyframes injected locally to ensure 60fps animations */}
      <style dangerouslySetInnerHTML={{ __html: `
        @keyframes float-particle {
          0%, 100% { transform: translateY(0) translateX(0); opacity: 0.2; }
          50% { transform: translateY(-40px) translateX(15px); opacity: 0.8; }
        }
        .animate-float-particle {
          animation: float-particle var(--duration) ease-in-out infinite;
        }
        @keyframes glow-blinking {
          0%, 100% {
            box-shadow: 0 0 16px rgba(242, 154, 12, 0.75), 0 0 32px rgba(255, 122, 0, 0.45);
            filter: brightness(1);
          }
          50% {
            box-shadow: 0 0 32px rgba(242, 154, 12, 1), 0 0 60px rgba(255, 122, 0, 0.8), inset 0 0 14px rgba(255, 255, 255, 0.5);
            filter: brightness(1.18);
          }
        }
        .animate-glow-blinking {
          animation: glow-blinking 1.8s ease-in-out infinite;
        }
      `}} />
      {/* HeroSection*/}
      <HeroSection/>

      {/* ══════════════════════════════════════════
          BENEFITS
      ══════════════════════════════════════════ */}
      <section className="relative w-full overflow-hidden bg-[#FFF8EE] py-14 lg:py-20">
        <motion.div animate={{ opacity:[0.15,0.22,0.15] }} transition={{ repeat:Infinity, duration:10 }}
          className="absolute top-[-250px] left-[-220px] w-[700px] h-[700px] rounded-full bg-[radial-gradient(circle,rgba(242,154,12,0.2)_0%,transparent_70%)] pointer-events-none will-change-opacity" />
        <motion.div animate={{ opacity:[0.12,0.18,0.12] }} transition={{ repeat:Infinity, duration:12 }}
          className="absolute bottom-[-300px] right-[-200px] w-[700px] h-[700px] rounded-full bg-[radial-gradient(circle,rgba(104,138,94,0.2)_0%,transparent_70%)] pointer-events-none will-change-opacity" />

        <div className="relative z-20 max-w-[1450px] mx-auto px-6 lg:px-20">
          <Reveal className="w-full text-center">
            <Badge label="WHY DIVYYOG FOUNDATION"/>
            <h2 className="text-[44px] md:text-[72px] leading-[1.26] tracking-[-1px] font-semibold mt-7" style={{ fontFamily:"Poppins" }}>
              <span className="text-[#111]">Wellness Designed</span><br/>
              <span className="text-[#F29A0C]">For Modern Living</span>
            </h2>
            <p className="text-[#555] text-lg md:text-[20px] leading-[38px] mt-8 text-center">
              Experience cinematic wellness journeys crafted through immersive yoga, mindfulness, meditation, and transformational healing experiences.
            </p>
          </Reveal>
        </div>

        <div ref={sectionRef} className="relative mt-14 z-20 max-w-[1450px] mx-auto px-6 lg:px-20">
          <div className="grid grid-cols-1 lg:grid-cols-[0.82fr_1fr] gap-14 items-center">
            {/* Benefits Image with overlay controls - visible on both mobile & desktop */}
            <div className="relative h-[380px] sm:h-[480px] md:h-[540px] lg:h-[820px] flex items-center justify-center">
              <motion.div animate={{ y:[0,-20,0] }} transition={{ repeat:Infinity, duration:8 }}
                className="absolute w-[300px] h-[300px] sm:w-[420px] sm:h-[420px] lg:w-[520px] lg:h-[520px] rounded-full bg-[radial-gradient(circle,rgba(242,154,12,0.15)_0%,transparent_70%)] pointer-events-none" />
              
              {/* Relative wrapper specifically for the card */}
              <div className="relative w-full max-w-[280px] sm:max-w-[380px] md:max-w-[420px] lg:max-w-[480px] h-[320px] sm:h-[420px] md:h-[480px] lg:h-[560px] flex items-center justify-center">
                <AnimatePresence mode="wait">
                  <motion.div key={benefitsData[activeBenefit].id}
                    drag={isMobile ? "x" : false}
                    dragConstraints={{ left: 0, right: 0 }}
                    dragElastic={0.4}
                    onDragEnd={(e, info) => {
                      const threshold = 50;
                      if (info.offset.x < -threshold) {
                        setActiveBenefit(p => (p === benefitsData.length - 1 ? 0 : p + 1));
                      } else if (info.offset.x > threshold) {
                        setActiveBenefit(p => (p === 0 ? benefitsData.length - 1 : p - 1));
                      }
                    }}
                    initial={{ opacity:0, y:40, scale:0.96, filter:"blur(8px)" }}
                    animate={{ opacity:1, y:0, scale:1, filter:"blur(0px)" }}
                    exit={{ opacity:0, y:-40, scale:0.96, filter:"blur(8px)" }}
                    transition={{ duration:0.85, ease:[0.16, 1, 0.3, 1] }}
                    style={{ willChange: "transform, opacity", touchAction: "pan-y" }}
                    className="relative z-20 w-full h-full rounded-[42px] overflow-hidden border border-white/20 shadow-[0_60px_160px_rgba(0,0,0,0.22)] cursor-grab active:cursor-grabbing">
                    <motion.img src={benefitsData[activeBenefit].image} alt={benefitsData[activeBenefit].title}
                      animate={{ scale:[1,1.04,1] }} transition={{ repeat:Infinity, duration:12 }}
                      whileHover={{ scale:1.08, rotate:-1, filter:"brightness(1.08)" }}
                      style={{ willChange: "transform" }}
                      className="w-full h-full object-cover transition-all duration-700 cursor-pointer pointer-events-none select-none"/>
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/10 to-transparent pointer-events-none" />
                    <div className="absolute inset-0 bg-gradient-to-r from-[#F29A0C]/20 via-transparent to-[#FFF8EE]/10 pointer-events-none" />
                    <motion.div animate={{ y:[0,-8,0] }} transition={{ repeat:Infinity, duration:4 }}
                      className="absolute left-6 bottom-6 bg-white/10 border border-white/20 backdrop-blur-2xl rounded-[24px] px-5 py-4 pointer-events-none">
                      <p className="text-white text-[11px] tracking-[4px] uppercase">{benefitsData[activeBenefit].highlight}</p>
                    </motion.div>
                  </motion.div>
                </AnimatePresence>
              </div>
            </div>

            <div className="relative min-h-[520px] flex items-center w-full">
              <AnimatePresence mode="wait">
                <motion.div key={benefitsData[activeBenefit].id}
                  drag={isMobile ? "x" : false}
                  dragConstraints={{ left: 0, right: 0 }}
                  dragElastic={0.4}
                  onDragEnd={(e, info) => {
                    const threshold = 50;
                    if (info.offset.x < -threshold) {
                      setActiveBenefit(p => (p === benefitsData.length - 1 ? 0 : p + 1));
                    } else if (info.offset.x > threshold) {
                      setActiveBenefit(p => (p === 0 ? benefitsData.length - 1 : p - 1));
                    }
                  }}
                  initial={{ opacity:0, y:50, scale:0.96, filter:"blur(12px)" }}
                  animate={{ opacity:1, y:0, scale:1, filter:"blur(0px)" }}
                  exit={{ opacity:0, y:-50, scale:0.96, filter:"blur(12px)" }}
                  transition={{ duration:1, ease:[0.22,1,0.36,1] }}
                  style={{ touchAction: "pan-y" }}
                  className="max-w-[680px] w-full cursor-grab active:cursor-grabbing">
                  <div className="flex items-center gap-7">
                    <motion.div initial={{ opacity:0, scale:0.8 }} animate={{ opacity:1, scale:1 }} transition={{ delay:0.15, duration:0.6 }}
                      className="w-16 h-16 rounded-[28px] bg-gradient-to-br from-[#F29A0C] to-[#FF7A00] flex items-center justify-center text-white text-[30px] shadow-[0_20px_50px_rgba(242,154,12,0.35)]">
                      {benefitsData[activeBenefit].icon}
                    </motion.div>
                    <span className="text-[60px] leading-none font-bold text-[#F29A0C]/12">{benefitsData[activeBenefit].number}</span>
                    <motion.div layoutId="line" className="w-24 h-[2px] bg-gradient-to-r from-[#F29A0C] to-transparent" />
                  </div>
                  <h3 className="text-[42px] md:text-[58px] leading-[1.02] tracking-[-2px] font-semibold mt-10" style={{ fontFamily:"Poppins" }}>
                    <span className="text-[#111]">{benefitsData[activeBenefit].title.split(" ").slice(0,2).join(" ")}</span><br/>
                    <span className="text-[#F29A0C]">{benefitsData[activeBenefit].title.split(" ").slice(2).join(" ")}</span>
                  </h3>
                  <motion.div initial={{ opacity:0, y:20 }} animate={{ opacity:1, y:0 }} transition={{ delay:0.2, duration:0.8 }}
                    className="inline-flex items-center gap-3 px-5 py-3 rounded-full bg-[#F29A0C]/10 border border-[#F29A0C]/20 mt-8">
                    <div className="w-2 h-2 rounded-full bg-[#F29A0C]" />
                    <span className="text-[#F29A0C] tracking-[3px] uppercase text-xs font-semibold">{benefitsData[activeBenefit].highlight}</span>
                  </motion.div>
                  <motion.p initial={{ opacity:0, y:20 }} animate={{ opacity:1, y:0 }} transition={{ delay:0.3, duration:0.8 }}
                    className="text-[#555] text-lg md:text-[20px] leading-[38px] mt-10 max-w-[640px]">
                    {benefitsData[activeBenefit].subtitle}
                  </motion.p>
                  <div className="flex flex-wrap items-center gap-4 mt-16">
                    {benefitsData.map((_, i) => (
                      <button key={i} onClick={() => setActiveBenefit(i)}
                        className={`rounded-full transition-all duration-700 ${activeBenefit===i ? "w-16 h-3 bg-[#F29A0C]" : "w-3 h-3 bg-[#D7C5A8]"}`} />
                    ))}
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
          ABOUT / PHILOSOPHY
      ══════════════════════════════════════════ */}
      <section className="relative w-full overflow-hidden">
        <div className="absolute inset-0 bg-fixed bg-cover bg-center" style={{ backgroundImage:"url('/assets/image 19.jpeg')" }} />
        <div className="absolute inset-0 bg-black/60 z-[1]" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/45 to-black/50 z-[2]" />
        <div className="absolute top-0 left-0 w-full h-[220px] bg-gradient-to-b from-[#F29A0C]/50 to-transparent z-[3]" />
        <div className="absolute bottom-0 left-0 w-full h-[220px] bg-gradient-to-t from-[#F29A0C]/40 to-transparent z-[3]" />
        <motion.div animate={{ opacity:[0.12,0.22,0.12] }} transition={{ repeat:Infinity, duration:10 }}
          className="absolute top-[-200px] left-[-180px] w-[700px] h-[700px] rounded-full bg-[radial-gradient(circle,rgba(242,154,12,0.6)_0%,transparent_70%)] z-[2] pointer-events-none will-change-opacity" />
        <motion.div animate={{ opacity:[0.08,0.14,0.08] }} transition={{ repeat:Infinity, duration:12 }}
          className="absolute bottom-[-250px] right-[-180px] w-[700px] h-[700px] rounded-full bg-[radial-gradient(circle,rgba(242,154,12,0.6)_0%,transparent_70%)] z-[2] pointer-events-none will-change-opacity" />
        <div className="absolute inset-0 z-[3] overflow-hidden pointer-events-none">
          {particles.map((p) => (
            <span key={p.id} className="absolute rounded-full bg-white/30 animate-float-particle"
              style={{
                width: p.width,
                height: p.height,
                top: p.top,
                left: p.left,
                animationDelay: p.delay,
                "--duration": p.duration,
                willChange: "transform, opacity"
              }}
            />
          ))}
        </div>

        <div className="relative z-20 max-w-[1450px] mx-auto px-6 lg:px-20 py-40 lg:py-40">
          <Reveal className="max-w-[850px]">
            <Badge label="ABOUT DIVYYOG FOUNDATION" dark/>
            <h2 className="text-[48px] md:text-[72px] leading-[1.04] tracking-[-1px] font-semibold mt-8" style={{ fontFamily:"Poppins" }}>
              <span className="text-white">Ancient Yoga Wisdom</span><br/>
              <span className="text-[#F29A0C]">For Modern Wellness</span>
            </h2>
          </Reveal>

          <div className="grid grid-cols-1 lg:grid-cols-[1fr_0.85fr] gap-28 mt-12 items-start">
            <Reveal delay={0.1}>
              <p className="text-white/90 text-lg md:text-[21px] leading-[42px] max-w-[720px]">
                Divyyog Foundation is a premium wellness platform designed to reconnect individuals with mindfulness, balance, healing, and conscious living through immersive yoga experiences.<br/><br/>
                Combining timeless yogic philosophy with cinematic modern digital experiences, we create transformational wellness journeys that inspire emotional clarity, inner peace, and spiritual growth across the world.
              </p>
              <motion.div initial={{ opacity:0, y:40 }} whileInView={{ opacity:1, y:0 }} viewport={{ once:true }} transition={{ delay:0.2, duration:1 }}
                className="mt-16 bg-white/10 backdrop-blur-2xl border border-white/10 rounded-[40px] p-10 shadow-[0_30px_100px_rgba(0,0,0,0.18)] max-w-[720px]">
                <p className="text-[30px] md:text-[44px] leading-[1.35] italic text-white" style={{ fontFamily:"Cormorant Garamond" }}>
                  "Yoga is not simply movement. It is alignment of mind, body, energy, and purpose."
                </p>
              </motion.div>
              <motion.div initial={{ opacity:0, y:30 }} whileInView={{ opacity:1, y:0 }} viewport={{ once:true }} transition={{ delay:0.3, duration:1 }}
                className="mt-16">
                <Link to="/about-us">
                  <button className="group relative overflow-hidden px-8 py-4 rounded-full bg-gradient-to-r from-[#F29A0C] to-[#FF7A00] text-white text-[15px] font-semibold shadow-[0_15px_40px_rgba(242,154,12,0.35)] hover:scale-105 transition-all duration-500 cursor-pointer">
                    <span className="relative z-10 flex items-center gap-3">Discover Our Philosophy<FaArrowRight/></span>
                    <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-all duration-500" />
                  </button>
                </Link>
              </motion.div>
            </Reveal>

            <div className="relative flex flex-col gap-8">
              {[
                { delay:0.2, content: (
                  <>
                    <Badge label="Global Wellness Platform" dark/>
                    <h3 className="text-white text-[72px] leading-none font-semibold mt-6">10K+</h3>
                    <p className="text-white/70 leading-[34px] mt-5 text-lg">Active members transforming their wellness journey through immersive yoga, mindfulness, and meditation experiences.</p>
                  </>
                )},
              ].map(({ delay, content }, i) => (
                <motion.div key={i} initial={{ opacity:0, x:60 }} whileInView={{ opacity:1, x:0 }} viewport={{ once:true }} transition={{ delay, duration:1 }}
                  animate={{ y:[0,-12,0] }}
                  className="bg-white/10 backdrop-blur-2xl border border-white/10 rounded-[36px] p-8 shadow-[0_30px_100px_rgba(0,0,0,0.18)]">
                  {content}
                </motion.div>
              ))}
              <motion.div initial={{ opacity:0, x:60 }} whileInView={{ opacity:1, x:0 }} viewport={{ once:true }} transition={{ delay:0.3, duration:1 }}
                animate={{ y:[0,-10,0] }}
                className="relative overflow-hidden rounded-[40px] border border-white/10 shadow-[0_30px_100px_rgba(0,0,0,0.2)]">
                <img src="/assets/image 13.jpeg" alt="Yoga Wellness" className="w-full h-[420px] object-cover"/>
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                <div className="absolute bottom-6 left-6 bg-white/10 backdrop-blur-2xl border border-white/10 rounded-full px-6 py-3">
                  <span className="text-white tracking-[4px] uppercase text-xs">Daily Live Yoga Sessions</span>
                </div>
              </motion.div>
              <motion.div initial={{ opacity:0, x:60 }} whileInView={{ opacity:1, x:0 }} viewport={{ once:true }} transition={{ delay:0.4, duration:1 }}
                className="grid grid-cols-2 gap-6">
                {[["40+","Countries Reached"],["Daily","Live Sessions"]].map(([val, label]) => (
                  <div key={label} className="bg-white/10 backdrop-blur-2xl border border-white/10 rounded-[32px] p-7">
                    <h3 className="text-white text-[48px] font-semibold">{val}</h3>
                    <p className="text-white/70 mt-3">{label}</p>
                  </div>
                ))}
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
          PROGRAMS
      ══════════════════════════════════════════ */}
      <section className="relative w-full overflow-hidden bg-[#FFF8EE] py-20">
        <motion.div animate={{ opacity:[0.06,0.12,0.06] }} transition={{ repeat:Infinity, duration:10 }}
          className="absolute top-[-220px] left-[-180px] w-[600px] h-[600px] rounded-full bg-[radial-gradient(circle,rgba(242,154,12,0.2)_0%,transparent_70%)] pointer-events-none will-change-opacity" />
        <motion.div animate={{ opacity:[0.04,0.08,0.04] }} transition={{ repeat:Infinity, duration:12 }}
          className="absolute bottom-[-220px] right-[-180px] w-[600px] h-[600px] rounded-full bg-[radial-gradient(circle,rgba(104,138,94,0.1)_0%,transparent_70%)] pointer-events-none will-change-opacity" />

        <div className="relative z-20 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 px-6 lg:px-20 mb-14">
          <Reveal className="max-w-[720px]">
            <Badge label="EXPLORE PROGRAMS"/>
            <h2 className="text-[40px] md:text-[64px] leading-[1.04] tracking-[-1px] font-semibold mt-6" style={{ fontFamily:"Poppins" }}>
              <span className="text-[#111]">Curated Wellness</span><br/>
              <span className="text-[#F29A0C]">Experiences</span>
            </h2>
          </Reveal>
          <div className="flex flex-row items-center justify-between lg:justify-end gap-6 w-full lg:w-auto">
            <a href="/courses" className="group flex items-center gap-4 text-[#111] font-semibold text-[15px]">
              View All Programs
              <div className="w-12 h-12 rounded-full bg-white border border-[#E8D9C7] flex items-center justify-center group-hover:bg-[#F29A0C] group-hover:text-white transition-all duration-500">
                <FaArrowRight/>
              </div>
            </a>
          </div>
        </div>

        <div 
          ref={scrollRef} 
          onMouseDown={isMobile ? undefined : handleMouseDown}
          style={{ willChange: "scroll-position" }} 
          className={`relative flex gap-5 overflow-x-auto overflow-y-hidden px-6 lg:px-20 py-6 hide-scrollbar scroll-smooth whitespace-nowrap ${isMobile ? "" : "cursor-grab select-none active:cursor-grabbing"}`}
        >
          {(isMobile ? programsData : [...programsData, ...programsData]).map((program, i) => (
            <motion.a href={program?.link} key={i}
              onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)}
              onFocus={() => setIsPaused(true)} onBlur={() => setIsPaused(false)}
              whileHover={{ y:-10 }} transition={{ duration:0.4 }}
              className="group relative w-[280px] min-w-[280px] max-w-[280px] h-[320px] rounded-[32px] overflow-hidden flex-shrink-0 cursor-pointer z-20">
              <motion.img whileHover={{ scale:1.08 }} transition={{ duration:1 }}
                src={program?.image} loading="lazy" alt={program?.title}
                className="absolute inset-0 w-full h-full object-cover pointer-events-none select-none"/>
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/25 to-black/20" />
              <div className="absolute inset-0 bg-[#F29A0C]/0 group-hover:bg-[#F29A0C]/10 transition-all duration-700" />
              <div className="absolute inset-0 rounded-[32px] border border-[#f29a0cf0] group-hover:border-[#F29A0C]/50 transition-all duration-700" />
              <div className="absolute inset-0 rounded-[32px] opacity-0 group-hover:opacity-100 shadow-[0_35px_120px_rgba(242,154,12,0.94)] border-4 border-[#f29a0cf0] transition-all duration-700" />
              <div className="relative z-20 flex flex-col justify-between h-full p-5">
                <div className="flex items-start justify-between">
                  <motion.div whileHover={{ rotate:6, scale:1.06 }}
                    className="w-12 h-12 rounded-[18px] bg-white/10 backdrop-blur-2xl border-2 border-[#f29a0cf0] flex items-center justify-center text-white text-[18px]">
                    {program?.icon}
                  </motion.div>
                  <div className="bg-white/10 backdrop-blur-2xl border border-white/10 rounded-full px-3 py-2">
                    <span className="text-white text-[9px] tracking-[3px] uppercase">{program?.level}</span>
                  </div>
                </div>
                <div>
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-2 h-2 rounded-full bg-[#F29A0C]" />
                    <span className="text-[#F29A0C] tracking-[3px] uppercase text-[10px] font-semibold">{program?.duration}</span>
                  </div>
                  <h3 className="text-[28px] leading-[1.02] tracking-[-2px] font-semibold text-white" style={{ fontFamily:"Poppins" }}>{program?.title}</h3>
                  <motion.div initial={{ opacity:0, y:20 }} whileHover={{ opacity:1, y:0 }}
                    className="flex items-center gap-3 mt-6 text-white/90">
                    <span className="text-[10px] tracking-[3px] uppercase">Explore More</span>
                    <div className="w-8 h-8 rounded-full bg-white/10 backdrop-blur-xl border border-white/10 flex items-center justify-center">
                      <FaArrowRight size={10}/>
                    </div>
                  </motion.div>
                </div>
              </div>
            </motion.a>
          ))}
        </div>
      </section>

      {/* ══════════════════════════════════════════
          LIVE CLASSES
      ══════════════════════════════════════════ */}
      <section ref={liveClassesRef} className="relative overflow-hidden py-16 bg-gradient-to-br from-[#f29a0c] via-[#f29a0c]/3 to-[#FFFFFF]">
        <div className="absolute top-[-250px] right-[-180px] w-[700px] h-[700px] rounded-full bg-[radial-gradient(circle,rgba(242,154,12,0.03)_0%,transparent_70%)] pointer-events-none" />
        <div className="absolute bottom-[-250px] left-[-180px] w-[700px] h-[700px] rounded-full bg-[radial-gradient(circle,rgba(242,154,12,0.03)_0%,transparent_70%)] pointer-events-none" />
        {[...Array(12)].map((_, i) => (
          <div key={i} className="absolute rounded-full bg-[#F29A0C]/20 animate-float-particle pointer-events-none"
            style={{
              width: `${8+i}px`,
              height: `${8+i}px`,
              top: `${i*8}%`,
              left: `${i*7}%`,
              animationDelay: `${i * 0.3}s`,
              "--duration": `${5 + i}s`,
              willChange: "transform, opacity"
            }} />
        ))}

        <div className="relative z-20 max-w-[1450px] mx-auto px-6 lg:px-20">
          <Reveal className="max-w-[760px]">
            <Badge label="LIVE YOGA EXPERIENCE" dark/>
            <h2 className="text-[44px] md:text-[74px] leading-[1.20] tracking-[-1px] font-semibold mt-6" style={{ fontFamily:"Poppins" }}>
              <span className="text-[#111111]">Join Live</span><br/>
              <span className="text-[#FFFFFF]">Virtual Classes</span>
            </h2>
            <p className="text-[#FFFFFF] text-lg md:text-[19px] leading-[36px] mt-8 max-w-[680px]">
              Experience immersive real time yoga sessions from anywhere in the world with expert guidance, interactive wellness learning, and premium virtual experiences.
            </p>
          </Reveal>

          <div className="grid grid-cols-1 lg:grid-cols-[0.9fr_1fr] gap-20 items-start mt-20">
            <div className="sticky top-24">
              <motion.div initial={{ opacity:0, x:-60 }} whileInView={{ opacity:1, x:0 }} viewport={{ once:true }} transition={{ duration:1 }}
                className="relative overflow-hidden rounded-[42px] border border-white/30 bg-white/20 backdrop-blur-2xl shadow-[0_40px_120px_rgba(242,154,12,0.12)]">
                <video id="liveYogaVideo" className="w-full h-[760px] object-cover" poster="/assets/image 42.jpeg" playsInline preload="none" loading="lazy"
                  style={{ willChange:"transform", transform:"translateZ(0)", backfaceVisibility:"hidden" }}>
                  <source src="/assets/video17.mp4" type="video/mp4" />
                </video>
                <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent" />
                <motion.div animate={{ opacity:[1,0.6,1] }} transition={{ repeat:Infinity, duration:2 }}
                  className="absolute top-6 left-6 bg-white/85 backdrop-blur-xl border border-white/50 rounded-full px-5 py-3 shadow-md">
                  <div className="flex items-center gap-3">
                    <div className={`w-3 h-3 rounded-full ${isLiveNow ? "bg-red-500 animate-ping" : "bg-[#F29A0C]"}`} />
                    <span className={`tracking-[3px] uppercase text-xs font-bold ${isLiveNow ? "text-red-600" : "text-[#111111]"}`}>
                      {isLiveNow ? "LIVE NOW" : "SCHEDULED LIVE"}
                    </span>
                  </div>
                </motion.div>
                <div className="absolute top-6 right-6 bg-white/15 backdrop-blur-2xl border border-white/20 rounded-full px-5 py-3">
                  <span className="text-black text-sm">10K+ Active Students</span>
                </div>
                <div className="absolute bottom-6 left-6 right-6 flex items-center justify-between flex-wrap gap-3">
                  {isLiveNow ? (
                    !authState.loggedIn ? (
                      <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.96 }}
                        onClick={handleLiveSessionJoin}
                        className="px-7 py-4 rounded-full bg-gradient-to-r from-[#F29A0C] to-[#FF8A00] text-white font-bold tracking-[2px] uppercase text-xs shadow-[0_20px_60px_rgba(242,154,12,0.35)] border border-[#FFD089]/30 backdrop-blur-2xl flex items-center gap-2.5 cursor-pointer transition-all duration-300"
                      >
                        <FaLock className="text-white/90 text-xs" />
                        <span>Register to Join Live</span>
                      </motion.button>
                    ) : isEligible ? (
                      <motion.button
                        whileHover={{ scale: 1.07 }}
                        whileTap={{ scale: 0.95 }}
                        onClick={handleLiveSessionJoin}
                        className="px-8 py-4 rounded-full bg-gradient-to-r from-[#F29A0C] via-[#FF8400] to-[#E08200] text-white font-extrabold tracking-[2px] uppercase text-xs animate-glow-blinking border-2 border-white ring-4 ring-[#F29A0C]/50 flex items-center gap-3 cursor-pointer shadow-[0_0_35px_rgba(242,154,12,0.85)]"
                      >
                        <span className="relative flex h-2.5 w-2.5">
                          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-90" />
                          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-white" />
                        </span>
                        <FaVideo className="text-sm" />
                        <span>Join Live Studio</span>
                      </motion.button>
                    ) : (
                      <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.96 }}
                        onClick={handleLiveSessionJoin}
                        className="px-7 py-4 rounded-full bg-gradient-to-r from-[#B45309] to-[#D97706] text-white font-bold tracking-[2px] uppercase text-xs shadow-[0_20px_60px_rgba(180,83,9,0.35)] border border-amber-300/40 backdrop-blur-2xl flex items-center gap-2 cursor-pointer transition-all duration-300"
                      >
                        <FaLock className="text-amber-200 text-xs" />
                        <span>Upgrade to Join Live</span>
                      </motion.button>
                    )
                  ) : (
                    <Link to="/live-classes">
                      <motion.button
                        whileHover={{ scale: 1.05 }}
                        whileTap={{ scale: 0.96 }}
                        className="px-7 py-4 rounded-full bg-white/90 hover:bg-white text-[#111111] font-bold tracking-[2px] uppercase text-xs shadow-[0_15px_40px_rgba(0,0,0,0.15)] border border-white/60 backdrop-blur-2xl flex items-center gap-2.5 cursor-pointer transition-all duration-300"
                      >
                        <FaArrowRight className="text-[#F29A0C] text-xs" />
                        <span>View Live Schedule</span>
                      </motion.button>
                    </Link>
                  )}

                  <motion.button
                    whileHover={{ scale: 1.08 }}
                    whileTap={{ scale: 0.94 }}
                    onClick={() => {
                      const video = document.getElementById("liveYogaVideo");
                      if (!video) return;
                      if (isVideoPlaying) {
                        video.pause();
                        setIsVideoPlaying(false);
                      } else {
                        video.play();
                        setIsVideoPlaying(true);
                      }
                    }}
                    className="w-16 h-16 rounded-full bg-white/15 backdrop-blur-2xl border border-white/20 flex items-center justify-center text-white shadow-[0_20px_60px_rgba(0,0,0,0.25)] cursor-pointer"
                  >
                    {isVideoPlaying ? <FaPause className="text-lg" /> : <FaPlay className="ml-1 text-lg" />}
                  </motion.button>
                </div>
              </motion.div>
            </div>

            <div className="space-y-4 mt-4">
              {liveSteps.map((step, i) => {
                const isActive = activeIndex === i;
                return (
                  <motion.div key={i}
                    initial={{ opacity:0, y:40 }} whileInView={{ opacity:1, y:0 }} viewport={{ once:true }} transition={{ duration:0.7, delay:i*0.08 }}
                    onClick={() => {
                      if (step.id === "03") handleLiveSessionJoin();
                      else if (step.id === "01") {
                        if (authState.loggedIn) navigate(authState.role.includes("admin") ? "/admin/dashboard" : "/user/dashboard");
                        else navigate("/register");
                      }
                    }}
                    style={{ zIndex: isActive ? 30 : 10 + i, willChange: "transform, opacity" }}
                    className={`-mt-20 group relative overflow-hidden rounded-[32px] border p-8 shadow-[0_20px_80px_rgba(0,0,0,0.08)] transition-all duration-700 cursor-pointer ${
                      isActive 
                        ? "border-[#F29A0C] bg-white shadow-[0_30px_100px_rgba(242,154,12,0.15)] scale-[1.02]" 
                        : "border-[#F4D9B5] bg-white/70 backdrop-blur-2xl hover:border-[#F29A0C]/30"
                    }`}>
                    <div className="absolute inset-0 bg-gradient-to-r from-[#F29A0C]/0 via-[#F29A0C]/5 to-[#F29A0C]/0 opacity-0 group-hover:opacity-100 transition-all duration-700 py-2" />
                    <div className="relative z-20 flex items-start gap-4">
                      <div className={`min-w-[58px] h-[58px] rounded-[24px] border flex items-center justify-center transition-all duration-500 ${
                        isActive ? "bg-[#F29A0C] border-[#F29A0C]" : "bg-[#FFF3E0] border-[#F4D9B5] group-hover:bg-[#F29A0C]"
                      }`}>
                        <span className={`text-xl font-semibold transition-all duration-500 ${
                          isActive ? "text-white" : "text-[#F29A0C] group-hover:text-white"
                        }`}>{step.id}</span>
                      </div>
                      <div className="flex-1">
                        <div className="flex items-start justify-between gap-1">
                          <h3 className="text-[24px] leading-none tracking-[-1px] font-semibold text-[#111111]">{step.title}</h3>
                          <div className={`w-11 h-11 rounded-full flex items-center justify-center transition-all duration-500 ${
                            isActive ? "bg-[#F29A0C] text-white" : "bg-[#FFF3E0] text-[#F29A0C] group-hover:bg-[#F29A0C] group-hover:text-white"
                          }`}>
                            <FaArrowRight size={12}/>
                          </div>
                        </div>
                        <p className="text-[#666666] text-[17px] leading-[18px] max-w-[90%]">{step.description}</p>
                      </div>
                    </div>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
          TESTIMONIALS
      ══════════════════════════════════════════ */}
      <section className="relative overflow-hidden py-16 bg-gradient-to-br from-[#FFF8EE] via-[#FFF4E8] to-[#FFFFFF]">
        <motion.div animate={{ opacity:[0.08,0.14,0.08] }} transition={{ repeat:Infinity, duration:10 }}
          className="absolute top-[-250px] right-[-180px] w-[700px] h-[700px] rounded-full bg-[radial-gradient(circle,rgba(242,154,12,0.15)_0%,transparent_70%)] pointer-events-none will-change-opacity" />
        <motion.div animate={{ opacity:[0.05,0.1,0.05] }} transition={{ repeat:Infinity, duration:12 }}
          className="absolute bottom-[-250px] left-[-180px] w-[700px] h-[700px] rounded-full bg-[radial-gradient(circle,rgba(242,154,12,0.1)_0%,transparent_70%)] pointer-events-none will-change-opacity" />
        {[...Array(10)].map((_, i) => (
          <div key={i} className="absolute rounded-full bg-[#F29A0C]/20 animate-float-particle pointer-events-none"
            style={{
              width: `${8+i}px`,
              height: `${8+i}px`,
              top: `${i*10}%`,
              left: `${i*8}%`,
              animationDelay: `${i * 0.4}s`,
              "--duration": `${5 + i}s`,
              willChange: "transform, opacity"
            }} />
        ))}

        <div className="relative z-20 max-w-[1450px] mx-auto px-6 lg:px-20">
          <Reveal className="max-w-[820px] mx-auto text-center">
            <Badge label="STUDENT TESTIMONIALS"/>
            <h2 className="text-[48px] md:text-[62px] leading-[1.12] tracking-[-1px] font-semibold mt-6" style={{ fontFamily:"Poppins" }}>
              <span className="text-[#111111]">Real Stories.</span><br/>
              <span className="text-[#F29A0C]">Real Transformation.</span>
            </h2>
            <p className="text-[#666666] text-lg md:text-[20px] leading-[38px] mt-2 max-w-[760px] mx-auto">
              Students worldwide are transforming their wellness journey through immersive yoga, mindful healing, and personalized guidance at Divyyog Foundation.
            </p>
          </Reveal>

          {/* Mobile View: Single Testimonial Card with manual swipe drag gesture (no chevron arrows on mobile) */}
          <div className="block lg:hidden relative mt-12 w-full">
            <div className="relative w-full max-w-[440px] mx-auto px-4 flex items-center justify-center">
              <AnimatePresence mode="wait">
                <motion.div
                  key={activeTestimonial}
                  drag="x"
                  dragConstraints={{ left: 0, right: 0 }}
                  dragElastic={0.4}
                  onDragEnd={(e, info) => {
                    const threshold = 50;
                    if (info.offset.x < -threshold) {
                      setActiveTestimonial(p => (p === testimonials.length - 1 ? 0 : p + 1));
                    } else if (info.offset.x > threshold) {
                      setActiveTestimonial(p => (p === 0 ? testimonials.length - 1 : p - 1));
                    }
                  }}
                  initial={{ opacity: 0, x: 30, filter: "blur(4px)" }}
                  animate={{ opacity: 1, x: 0, filter: "blur(0px)" }}
                  exit={{ opacity: 0, x: -30, filter: "blur(4px)" }}
                  transition={{ duration: 0.35, ease: "easeInOut" }}
                  style={{ touchAction: "pan-y" }}
                  className="group relative w-full overflow-hidden rounded-[32px] border border-white/40 bg-white/70 backdrop-blur-3xl p-6 sm:p-8 shadow-[0_20px_80px_rgba(0,0,0,0.06)] cursor-grab active:cursor-grabbing"
                >
                  <div className="absolute left-0 top-0 h-full w-[6px] bg-gradient-to-b from-[#F29A0C] via-[#FF7A00] to-[#F29A0C] pointer-events-none" />
                  <div className="relative z-20">
                    <div className="flex items-center justify-between pointer-events-none select-none">
                      <div className="flex items-center gap-3">
                        <div className="w-11 h-11 rounded-[16px] bg-[#FFF3E0] border border-[#F4D9B5] flex items-center justify-center">
                          <FaGoogle className="text-[#F29A0C] text-[18px]"/>
                        </div>
                        <div>
                          <div className="flex items-center gap-[1px] text-[18px] font-semibold leading-none">
                            <span className="text-[#4285F4]">G</span><span className="text-[#EA4335]">o</span>
                            <span className="text-[#FBBC05]">o</span><span className="text-[#4285F4]">g</span>
                            <span className="text-[#34A853]">l</span><span className="text-[#EA4335]">e</span>
                          </div>
                          <p className="text-[#666] text-[10px] tracking-[1.5px] uppercase mt-1">Verified Review</p>
                        </div>
                      </div>
                      <div className="w-12 h-12 rounded-full bg-[#FFF3E0] border border-[#F4D9B5] flex items-center justify-center text-[#F29A0C]">
                        <FaQuoteRight size={14}/>
                      </div>
                    </div>
                    
                    <p className="text-[#444] text-[15px] sm:text-[17px] leading-[26px] sm:leading-[32px] mt-8 min-h-[140px] select-none pointer-events-none">
                      "{testimonials[activeTestimonial].review}"
                    </p>

                    <div className="flex items-center justify-between mt-8 pointer-events-none select-none">
                      <div>
                        <h3 className="text-[#111111] text-[16px] sm:text-[18px] font-semibold">{testimonials[activeTestimonial].name}</h3>
                        <p className="text-[#777777] mt-1 text-[13px]">{testimonials[activeTestimonial].location}</p>
                      </div>
                      <div className="px-3 py-2 rounded-full bg-[#F29A0C]/10 border border-[#F29A0C]/20">
                        <span className="text-[#F29A0C] tracking-[2px] uppercase text-[9px] font-semibold">Verified</span>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </AnimatePresence>
            </div>

            {/* Dots Indicator */}
            <div className="flex items-center justify-center gap-2 mt-8">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setActiveTestimonial(i)}
                  className={`h-2.5 rounded-full transition-all duration-500 ${
                    activeTestimonial === i ? "w-8 bg-[#F29A0C]" : "w-2.5 bg-[#D7C5A8]"
                  }`}
                />
              ))}
            </div>
          </div>

          {/* Desktop View: Auto-scrolling Marquee */}
          <div className="hidden lg:block relative mt-16 overflow-hidden"
              onMouseEnter={() => playback.current?.pause()}
              onMouseLeave={() => playback.current?.play()}>
            {/* Blurs properly sized and blended to match background gradients on the sides */}
            <div className="absolute left-0 top-0 z-30 h-full w-24 xl:w-40 bg-gradient-to-r from-[#FFF8EE] to-transparent pointer-events-none" />
            <div className="absolute right-0 top-0 z-30 h-full w-24 xl:w-40 bg-gradient-to-l from-[#FFFFFF] to-transparent pointer-events-none" />
            <motion.div ref={marqueeRef} animate={{ x:["0%","-50%"] }} transition={{ repeat:Infinity, duration:26, ease:"linear" }}
              style={{ willChange: "transform" }}
              whileHover={{ animationPlayState:"paused" }} className="flex gap-8 w-max py-6">
              {[...testimonials, ...testimonials].map((item, i) => (
                <motion.div key={i} whileHover={{ y:-12, scale:1.02 }} transition={{ duration:0.5 }}
                  className="group relative w-[480px] min-w-[480px] overflow-hidden rounded-[40px] border border-white/40 bg-white/70 backdrop-blur-3xl p-10 shadow-[0_30px_120px_rgba(0,0,0,0.08)] hover:shadow-[0_40px_140px_rgba(242,154,12,0.18)] transition-all duration-700">
                  <div className="absolute left-0 top-0 h-full w-[8px] bg-gradient-to-b from-[#F29A0C] via-[#FF7A00] to-[#F29A0C]" />
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 bg-gradient-to-r from-[#F29A0C]/0 via-[#F29A0C]/5 to-[#F29A0C]/0 transition-all duration-700" />
                  <div className="relative z-20">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center gap-4">
                        <div className="w-14 h-14 rounded-[20px] bg-[#FFF3E0] border border-[#F4D9B5] flex items-center justify-center">
                          <FaGoogle className="text-[#F29A0C] text-[22px]"/>
                        </div>
                        <div>
                          <div className="flex items-center gap-[2px] text-[22px] font-semibold leading-none">
                            <span className="text-[#4285F4]">G</span><span className="text-[#EA4335]">o</span>
                            <span className="text-[#FBBC05]">o</span><span className="text-[#4285F4]">g</span>
                            <span className="text-[#34A853]">l</span><span className="text-[#EA4335]">e</span>
                          </div>
                          <p className="text-[#666] text-[12px] tracking-[2px] uppercase mt-2">Verified Reviews</p>
                          <div className="flex items-center gap-1 mt-3 text-[#F29A0C]">
                            {[...Array(5)].map((_, si) => <FaStar key={si} size={14}/>)}
                          </div>
                        </div>
                      </div>
                      <div className="w-16 h-16 rounded-full bg-[#FFF3E0] border border-[#F4D9B5] flex items-center justify-center text-[#F29A0C] group-hover:bg-[#F29A0C] group-hover:text-white transition-all duration-500">
                        <FaQuoteRight size={18}/>
                      </div>
                    </div>
                    <p className="text-[#444] text-[20px] leading-[38px] mt-10">"{item.review}"</p>
                    <div className="flex items-center justify-between mt-12">
                      <div>
                        <h3 className="text-[#111111] text-[24px] font-semibold">{item.name}</h3>
                        <p className="text-[#777777] mt-2 text-[15px]">{item.location}</p>
                      </div>
                      <div className="px-4 py-3 rounded-full bg-[#F29A0C]/10 border border-[#F29A0C]/20">
                        <span className="text-[#F29A0C] tracking-[3px] uppercase text-[10px] font-semibold">Verified Review</span>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </motion.div>
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
          STATS
      ══════════════════════════════════════════ */}
      <section className="relative overflow-hidden py-20">
        <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage:"url('https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&w=1200&q=70')", backgroundAttachment:"fixed" }} />
        <div className="absolute inset-0 bg-gradient-to-br from-[#F29A0C]/92 via-[#E88700]/88 to-[#D97706]/92" />
        <div className="absolute top-[-180px] right-[-180px] w-[500px] h-[500px] rounded-full bg-[radial-gradient(circle,rgba(255,255,255,0.1)_0%,transparent_70%)] pointer-events-none" />
        <div className="absolute bottom-[-180px] left-[-180px] w-[500px] h-[500px] rounded-full bg-[radial-gradient(circle,rgba(255,255,255,0.1)_0%,transparent_70%)] pointer-events-none" />
        {[...Array(8)].map((_, i) => (
          <div key={i} className="absolute rounded-full bg-white/20 animate-float-particle pointer-events-none"
            style={{
              width: `${6+i}px`,
              height: `${6+i}px`,
              top: `${i*12}%`,
              left: `${i*10}%`,
              animationDelay: `${i * 0.4}s`,
              "--duration": `${4 + i}s`,
              willChange: "transform, opacity"
            }} />
        ))}

        <div className="relative z-20 max-w-[1450px] mx-auto px-6 lg:px-20">
          <Reveal className="text-center max-w-[760px] mx-auto">
            <Badge label="GLOBAL COMMUNITY" dark/>
            <h2 className="text-[38px] md:text-[62px] leading-[0.95] tracking-[-2px] font-semibold text-white mt-5" style={{ fontFamily:"Poppins" }}>
              Our Growing<br/>Global Community
            </h2>
            <p className="text-white/80 text-[16px] md:text-[17px] leading-[34px] mt-6 max-w-[680px] mx-auto">
              Thousands of wellness seekers worldwide are transforming their lives through immersive yoga experiences and mindful practices at Divyyog Foundation.
            </p>
          </Reveal>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5 mt-16">
            {statsData.map((item, i) => (
              <motion.div key={item.id} initial={{ opacity:0, y:40 }} whileInView={{ opacity:1, y:0 }} viewport={{ once:true }} transition={{ duration:0.6, delay:i*0.05 }}
                whileHover={{ y:-8 }}
                className="group relative overflow-hidden rounded-[28px] border border-white/15 bg-white/10 backdrop-blur-2xl p-6 shadow-[0_20px_60px_rgba(0,0,0,0.10)] hover:bg-white/15 transition-all duration-500">
                <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-all duration-700 bg-gradient-to-br from-white/10 via-white/5 to-transparent" />
                <div className="absolute top-0 left-0 h-[2px] w-0 bg-white/80 group-hover:w-full transition-all duration-700" />
                <motion.div whileHover={{ rotate:8, scale:1.08 }}
                  className="relative z-20 w-12 h-12 rounded-[18px] bg-white/15 border border-white/20 flex items-center justify-center text-white text-[18px] group-hover:bg-white group-hover:text-[#F29A0C] transition-all duration-500">
                  {item.icon}
                </motion.div>
                <h3 className="relative z-20 text-[34px] leading-none font-semibold text-white mt-7 tracking-[-1px]">{item.number}</h3>
                <p className="relative z-20 text-white/80 text-[14px] leading-[26px] mt-4 min-h-[52px]">{item.title}</p>
                <div className="relative z-20 w-12 h-[2px] bg-white/30 mt-6 group-hover:w-20 transition-all duration-500" />
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════════════════════════════════════════
          PRICING
      ══════════════════════════════════════════ */}
      {/* <section className="relative overflow-hidden py-16 bg-gradient-to-br from-[#FFF8EF] via-[#FFF4E8] to-[#FFFFFF]">
        <div className="absolute inset-0 overflow-hidden">
          <motion.div animate={{ opacity:[0.12,0.2,0.12] }} transition={{ repeat:Infinity, duration:12 }}
            className="absolute top-[-350px] left-[-250px] w-[1000px] h-[1000px] rounded-full bg-[radial-gradient(circle,rgba(242,154,12,0.2)_0%,transparent_70%)] pointer-events-none will-change-opacity" />
          <motion.div animate={{ opacity:[0.08,0.16,0.08] }} transition={{ repeat:Infinity, duration:14 }}
            className="absolute bottom-[-350px] right-[-250px] w-[1000px] h-[1000px] rounded-full bg-[radial-gradient(circle,rgba(242,154,12,0.15)_0%,transparent_70%)] pointer-events-none will-change-opacity" />
          <motion.div animate={{ rotate:360 }} transition={{ repeat:Infinity, duration:80, ease:"linear" }}
            className="absolute left-1/2 top-1/2 w-[1400px] h-[1400px] rounded-full border border-[#F29A0C]/5 -translate-x-1/2 -translate-y-1/2" />
          <motion.div animate={{ rotate:-360 }} transition={{ repeat:Infinity, duration:100, ease:"linear" }}
            className="absolute left-1/2 top-1/2 w-[1000px] h-[1000px] rounded-full border border-[#F29A0C]/5 -translate-x-1/2 -translate-y-1/2" />
        </div>

        <div className="relative z-20 max-w-[1600px] mx-auto px-6 lg:px-20">
          <div className="grid grid-cols-1 lg:grid-cols-[0.8fr_1fr] gap-24 items-end">
            <Reveal>
              <Badge label="WELLNESS MEMBERSHIPS"/>
              <h2 className="text-[56px] md:text-[80px] leading-[1.2] tracking-[-1px] font-semibold mt-8" style={{ fontFamily:"Poppins" }}>
                Flexible<br/>Premium<br/>Wellness.
              </h2>
            </Reveal>
            <div className="max-w-[620px] lg:ml-auto">
              <p className="text-[#555555] text-[20px] leading-[42px]">
                Carefully designed wellness subscriptions built for mindful beginners, dedicated practitioners, and aspiring yoga instructors seeking immersive transformation.
              </p>
              <div className="flex items-center gap-5 mt-10">
                <div className="flex -space-x-4">
                  {[1,2,3,4].map(i => <img key={i} src={`https://i.pravatar.cc/150?img=${i+40}`} alt="" className="w-14 h-14 rounded-full border-4 border-white object-cover"/>)}
                </div>
                <div>
                  <h4 className="text-[#111111] text-[20px] font-semibold">10K+ Active Students</h4>
                  <p className="text-[#777777] mt-1">Trusted across 15+ countries</p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative mt-28 flex flex-col xl:flex-row gap-10 items-start">
            <div className="flex flex-col gap-6 w-full xl:w-[320px]">
              <PricingSideCard plan={pricingPlans[0]}/>
              <PricingSideCard plan={pricingPlans[1]}/>
            </div>

            <motion.div whileHover={{ y:-14 }}
              className="group relative overflow-hidden flex-1 rounded-[48px] bg-[#F29A0C] p-[1px] shadow-[0_60px_160px_rgba(242,154,12,0.28)]">
              <div className="absolute inset-0 bg-[conic-gradient(from_180deg,rgba(255,255,255,0.4),transparent,rgba(255,255,255,0.4))] opacity-40" />
              <div className="relative rounded-[48px] bg-gradient-to-br from-[#F29A0C] via-[#EA8B04] to-[#D97706] px-14 py-8 overflow-hidden">
                <div className="absolute top-[-120px] right-[-80px] w-[320px] h-[280px] rounded-full bg-white/10 blur-[80px]" />
                <div className="absolute top-8 right-8 bg-white text-[#F29A0C] rounded-full px-5 py-1 text-xs tracking-[3px] uppercase font-semibold">Most Popular</div>
                <div className="relative z-20">
                  <span className="text-white/70 uppercase tracking-[5px] text-xs font-semibold">Premium Wellness</span>
                  <h3 className="text-[50px] leading-none tracking-[-5px] font-semibold text-white mt-4">₹1,999</h3>
                  <p className="text-white text-[32px] font-semibold mt-3">Standard Membership</p>
                  <p className="text-white/75 text-[18px] leading-[36px] max-w-[640px]">
                    Unlimited wellness experiences including live classes, guided meditation, premium yoga programs, and immersive global community access.
                  </p>
                  <div className="grid sm:grid-cols-2 gap-5 mt-12">
                    {pricingPlans[2].features.map((f, i) => (
                      <div key={i} className="flex items-center gap-4">
                        <div className="w-2 h-2 rounded-full bg-white"/>
                        <span className="text-white/85 text-[16px]">{f}</span>
                      </div>
                    ))}
                  </div>
                   <Link to="/register">
                    <motion.button whileHover={{ scale:1.04 }} whileTap={{ scale:0.97 }}
                      className="mt-4 rounded-full bg-white text-[#F29A0C] px-10 py-2 text-[16px] font-semibold shadow-[0_20px_80px_rgba(0,0,0,0.18)] cursor-pointer">
                      Start Wellness Journey
                    </motion.button>
                  </Link>
                </div>
              </div>
            </motion.div>

            <div className="flex flex-col gap-6 w-full xl:w-[320px]">
              <PricingSideCard plan={pricingPlans[3]}/>
              <PricingSideCard plan={pricingPlans[4]}/>
            </div>
          </div>
        </div>
      </section> */}

      {/* ══════════════════════════════════════════
          CTA (BOTTOM)
      ══════════════════════════════════════════ */}
      <section className="relative overflow-hidden py-20 bg-[#FFF8EE]">
        <div className="absolute inset-0">
          <img src="/assets/image 25.jpeg" alt="" className="w-full h-[full] object-cover opacity-[0.99]" loading="lazy"/>
          <div className="absolute top-[-180px] left-[-120px] w-[500px] h-[500px] rounded-full bg-[radial-gradient(circle,rgba(242,154,12,0.15)_0%,transparent_70%)] pointer-events-none" />
          <div className="absolute bottom-[-220px] right-[-150px] w-[500px] h-[500px] rounded-full bg-[radial-gradient(circle,rgba(255,179,71,0.1)_0%,transparent_70%)] pointer-events-none" />
          <div className="absolute inset-0 bg-gradient-to-br from-[#FFF8EE]/75 via-[#FFF3E0]/65 to-[#FFFFFF]/70" />
        </div>

        <div className="relative z-20 max-w-[1350px] mx-auto px-6 lg:px-20">
          <motion.div
            onMouseMove={(e) => {
              const rect = e.currentTarget.getBoundingClientRect();
              rotateX.set(((e.clientY-rect.top)/rect.height-0.5)*-12);
              rotateY.set(((e.clientX-rect.left)/rect.width-0.5)*12);
            }}
            onMouseLeave={resetTilt}
            style={{ rotateX:smoothRotateX, rotateY:smoothRotateY, transformPerspective:1400, transformStyle:"preserve-3d", willChange:"transform" }}
            className="relative overflow-hidden rounded-[42px] border border-[#F4D9B5] bg-gradient-to-br from-white/10 via-[#FFF8EE]/20 to-[#FFE8C7]/30 backdrop-blur-3xl shadow-[0_30px_100px_rgba(242,154,12,0.08)] px-8 py-10 md:px-14 md:py-14">
            <div className="absolute top-[-100px] right-[-60px] w-[240px] h-[240px] rounded-full bg-[radial-gradient(circle,rgba(242,154,12,0.75)_0%,transparent_70%)] pointer-events-none" />
            <div className="absolute bottom-[-100px] left-[-60px] w-[240px] h-[240px] rounded-full bg-[radial-gradient(circle,rgba(255,179,71,0.7)_0%,transparent_70%)] pointer-events-none" />

            <div style={{ transform:"translateZ(40px)" }} className="grid grid-cols-1 lg:grid-cols-[1fr_340px] gap-14 items-center">
              <div>
                <div className="inline-flex items-center gap-3 rounded-full border border-[#F4D9B5] bg-white/70 px-5 py-3 backdrop-blur-xl">
                  <div className="w-2 h-2 rounded-full bg-[#F29A0C]"/>
                  <span className="text-[#F29A0C] text-[10px] tracking-[4px] uppercase font-semibold">DIVYYOG FOUNDATION</span>
                </div>
                <h2 className="text-[42px] md:text-[72px] leading-[1.2] tracking-[-1px] font-semibold text-[#111111] mt-8" style={{ fontFamily:"Poppins" }}>
                  Begin Your<br/>
                  <span className="text-[#F29A0C]">Wellness</span>
                  <span className="text-[#444444]"> Journey</span>
                </h2>
                <p className="text-[#222222] text-[17px] leading-[34px] mt-8 max-w-[700px]">
                  Experience immersive yoga, mindful healing, meditation, and transformational wellness guided by globally trusted instructors.
                </p>
                <div className="flex flex-wrap items-center gap-4 mt-10">
                  <Link to="/pricing">
                    <button className="btn-shine rounded-full bg-gradient-to-r from-[#F29A0C] to-[#FF8A00] text-white px-8 py-4 text-[14px] font-semibold shadow-[0_20px_60px_rgba(242,154,12,0.25)] hover:scale-105 transition-all duration-500 cursor-pointer">
                      Start Free Trial
                    </button>
                  </Link>
                  <Link to="/courses">
                    <button className="rounded-full border border-[#F4D9B5] bg-white/70 text-[#111111] px-8 py-4 text-[14px] font-semibold hover:bg-[#F29A0C] hover:text-white transition-all duration-500 cursor-pointer">
                      Explore Programs
                    </button>
                  </Link>
                </div>
              </div>
              <div className="hidden md:block relative overflow-hidden rounded-[30px] border border-[#F4D9B5] bg-gradient-to-br from-white/80 to-[#FFF3E0]/80 backdrop-blur-2xl p-7 w-full h-full shadow-[0_20px_60px_rgba(242,154,12,0.08)]">
                <img src="/assets/image 42.jpeg" alt="" className="absolute inset-0 w-[100] h-[100]  object-fill opacity-[.78]" loading="lazy"/>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </>
  );
};

export default React.memo(Home);